import { createRoutesFromElements, Navigate, Route } from 'react-router';
import { DYNAMIC_PATH, PATH } from '@old/data/core/paths';
import {
  DashboardPage,
  SilobagListPage,
  SilobagCreatePage,
  SilobagEditPage,
  ReportDevices,
  AdministratorPage,
  NotificactionPage,
  ActivityReportPage,
} from '@old/pages/private';
import { MapPage } from '@old/pages/private/map';
import { StockPage } from '@old/pages/private/report-stock';
import { SilobagDetails } from '@old/pages/private/silobag-detail';
import {
  LoginPage,
  ForgotPasswordPage,
  VerifyRegisterPage,
  RegisterPage,
  CompleteRegister,
  VerifyResetAccount,
  ResetPage,
  AuthCallbackPage,
  OnboardingPage,
  ErrorPublicPage,
} from '@old/pages/public';
import NotFoundPage from '@old/pages/public/not-found';
import { PrivatePagesLayout } from '@old/ui/private-layout/private-layout';
import { ProtectedRoute } from './protected-routes';
import { StateStockPage } from '@old/pages/private/report-state-stock';
import { SkipRoute } from './public-routes';
import { useGlobalStore } from '@old/global-store/use-store';
import { ReportExitenceStockPage } from '@old/pages/private/report-existence-stock';
import { SiloInsurancePage } from '@old/features/silobag-insurance/silo-insurance';
import { NotConnectedPage } from '@old/pages/public/not-connected';
import { SyncCorvusContainer } from '@old/pages/private/sync-corvus-container';
import { ErrorScreen } from './error-screen';
import { InconsistenciesPage } from '@old/pages/private/inconsistencies';
// import { ReportPositionGeneral } from '@old/features/report-position-general/report-position-general';

import { SilometrixThresholdPage } from '@old/pages/private/silometrix-threshold';
import { ReportPositionGeneral } from '@old/features/report-position-general/report-position-general';

// import { ReportPositionGeneral } from '@old/features/report-position-general/report-position-general';
import { WarrantsPage } from '@old/pages/private/warrants';
import { SilobagArchived } from '@old/pages/private/silobag-archived';
import { PlastarRegisterPage } from '@old/pages/public/register-plastar';
import { NeraRegisterPage } from '@old/pages/public/register-nera';
import { AgrologyRegisterPage } from '@old/pages/public/register-agrology';
import { LartirigoyenRegisterPage } from '@old/pages/public/register-lartirigoyen';
import { EdpRegisterPage } from '@old/pages/public/register-edp';

const email = useGlobalStore.getState().email;
const isUserConnected = useGlobalStore.getState().isUserOnline;

export const oldRoutes = createRoutesFromElements(
  <>
    <Route errorElement={<ErrorScreen />}>
      {/* PUBLIC ROUTES */}
      <Route path={PATH.LOGIN} element={<LoginPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.AUTH_CALLBACK} element={<AuthCallbackPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.ONBOARDING} element={<OnboardingPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.ERROR} element={<ErrorPublicPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.FORGOT_PASSWORD} element={<ForgotPasswordPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.VERIFY_REGISTER} element={<VerifyRegisterPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.REGISTER} element={<RegisterPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.REGISTER_PLASTAR} element={<PlastarRegisterPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.REGISTER_NERA} element={<NeraRegisterPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.REGISTER_EDP} element={<EdpRegisterPage />} errorElement={<ErrorScreen />} />
      <Route
        path={PATH.REGISTER_AGROLOGY}
        element={<AgrologyRegisterPage />}
        errorElement={<ErrorScreen />}
      />
      <Route
        path={PATH.REGISTER_LARTIRIGOYEN}
        element={<LartirigoyenRegisterPage />}
        errorElement={<ErrorScreen />}
      />
      <Route path={PATH.REGISTER_EDP} element={<EdpRegisterPage />} errorElement={<ErrorScreen />} />
      <Route path={PATH.COMPLETE_REGISTER} element={<CompleteRegister />} errorElement={<ErrorScreen />} />
      <Route
        path={PATH.VERIFY_RESET_ACCOUNT}
        element={<VerifyResetAccount />}
        errorElement={<ErrorScreen />}
      />
      <Route path={PATH.RESET} element={<ResetPage />} errorElement={<ErrorScreen />} />
      {/* PLATFORM USER AUTH REQUIRED ROUTES */}
      <Route index element={<Navigate to={PATH.DASHBOARD} />} errorElement={<ErrorScreen />} />{' '}
      {/* default home */}
      <Route element={<ProtectedRoute />}>
        <Route element={<PrivatePagesLayout withHeader withFooter withSideSpaces />}>
          <Route path={PATH.DASHBOARD}>
            <Route index element={<DashboardPage />} errorElement={<ErrorScreen />} />
          </Route>

          <Route
            path={PATH.USER_NOTIFICATION}
            element={<NotificactionPage />}
            errorElement={<ErrorScreen />}
          />

          <Route path={PATH.SILOBAG}>
            <Route index element={<SilobagListPage />} errorElement={<ErrorScreen />} />
            <Route path={DYNAMIC_PATH.NEW} element={<SilobagCreatePage />} errorElement={<ErrorScreen />} />
            <Route
              path={DYNAMIC_PATH.INSURANCE}
              element={<SiloInsurancePage />}
              errorElement={<ErrorScreen />}
            />
            <Route
              path={DYNAMIC_PATH.CORVUS}
              element={<SyncCorvusContainer />}
              errorElement={<ErrorScreen />}
            />
            <Route
              path={DYNAMIC_PATH.ARCHIVED}
              element={<SilobagArchived />}
              errorElement={<ErrorScreen />}
            />
            <Route path={DYNAMIC_PATH.SILO_ID}>
              <Route index element={<SilobagDetails />} errorElement={<ErrorScreen />} />
              <Route path={DYNAMIC_PATH.EDIT} element={<SilobagEditPage />} errorElement={<ErrorScreen />} />
            </Route>
          </Route>
          <Route path={PATH.REPORT}>
            <Route path={DYNAMIC_PATH.STOCK} element={<StockPage />} errorElement={<ErrorScreen />} />
            <Route path={DYNAMIC_PATH.DEVICE} element={<ReportDevices />} errorElement={<ErrorScreen />} />
            <Route
              path={DYNAMIC_PATH.STATE_STOCK}
              element={<StateStockPage />}
              errorElement={<ErrorScreen />}
            />
            <Route
              path={DYNAMIC_PATH.ACTIVITY}
              element={<ActivityReportPage />}
              errorElement={<ErrorScreen />}
            />
            <Route
              path={DYNAMIC_PATH.EXISTENCE_STOCK}
              element={<ReportExitenceStockPage />}
              errorElement={<ErrorScreen />}
            />
            <Route
              path={DYNAMIC_PATH.POSITION_GENERAL}
              element={<ReportPositionGeneral />}
              errorElement={<ErrorScreen />}
            />
          </Route>
        </Route>
      </Route>
      <Route element={<ProtectedRoute />} errorElement={<ErrorScreen />}>
        <Route element={<PrivatePagesLayout withHeader fillAvailableSpace />}>
          <Route path={PATH.MAP}>
            <Route index element={<MapPage />} errorElement={<ErrorScreen />} />
            <Route path={DYNAMIC_PATH.SILO_ID} element={<MapPage />} errorElement={<ErrorScreen />} />
          </Route>
        </Route>
      </Route>
      <Route element={<ProtectedRoute />} errorElement={<ErrorScreen />}>
        <Route element={<PrivatePagesLayout withHeader />}>
          <Route path={PATH.INCONSISTENCIES}>
            <Route index element={<InconsistenciesPage />} errorElement={<ErrorScreen />} />
            <Route
              path={DYNAMIC_PATH.SILO_ID}
              element={<InconsistenciesPage />}
              errorElement={<ErrorScreen />}
            />
          </Route>
        </Route>
      </Route>
      {/* ADMIN AUTH REQUIRED ROUTES */}
      <Route element={<ProtectedRoute admin />} errorElement={<ErrorScreen />}>
        <Route element={<PrivatePagesLayout withHeader withFooter withSideSpaces />}>
          <Route path={PATH.ADMINISTRATOR}>
            <Route index element={<AdministratorPage />} errorElement={<ErrorScreen />} />
            <Route
              path={DYNAMIC_PATH.NOTIFICATION}
              element={<NotificactionPage />}
              errorElement={<ErrorScreen />}
            />
            <Route
              path={DYNAMIC_PATH.SILOMETRIX_THRESHOLD}
              element={<SilometrixThresholdPage />}
              errorElement={<ErrorScreen />}
            />
            <Route path={DYNAMIC_PATH.WARRANTS} element={<WarrantsPage />} errorElement={<ErrorScreen />} />
          </Route>
        </Route>
      </Route>
      {/*
          NOT FOUND ROUTE (SOFT) // TODO: consultar
          No se envía un status 404, se resuelve con status 200
          El status 404 solo puede ser enviado desde servidor, no desde el cliente
          Se puede hacer un endpoint 404 que devuelva solo el status 404 para manejar esto
        */}
      <Route element={email ? <ProtectedRoute /> : <SkipRoute />} errorElement={<ErrorScreen />}>
        <Route
          element={
            email ? (
              <PrivatePagesLayout withHeader withFooter footerConfig={{ withMarginTop: false }} />
            ) : (
              <SkipRoute />
            )
          }
        >
          <Route>
            <Route path="*" element={<NotFoundPage />} errorElement={<ErrorScreen />} />
          </Route>
        </Route>
      </Route>
      <Route element={!isUserConnected && email ? <ProtectedRoute /> : <SkipRoute />}>
        <Route
          element={
            !isUserConnected && email ? (
              <PrivatePagesLayout withHeader withFooter footerConfig={{ withMarginTop: false }} />
            ) : (
              <SkipRoute />
            )
          }
        >
          <Route>
            <Route path={PATH.NO_CONNECTION} element={<NotConnectedPage />} errorElement={<ErrorScreen />} />
          </Route>
        </Route>
      </Route>
    </Route>
  </>
);
